import { Pill } from '@99designs/common/components/Pill';
import { DesignerLevel as Level } from '__generated__/types';
import * as React from 'react';

const Levels: { [level in Level]: { name: string; variation: string } } = {
    [Level.TOP]: { name: __('Top Level'), variation: 'top-level' },
    [Level.MID]: { name: __('Mid Level'), variation: 'mid-level' },
    [Level.ENTRY]: { name: __('Entry Level'), variation: 'entry-level' },
};

export interface Props {
    level: Level;
    size?: string;
}

const DesignerLevel = ({ level, size }: Props) => {
    const { name, variation } = Levels[level];

    return <Pill variations={[variation].concat(size ? [size] : [])}>{name}</Pill>;
};

export default DesignerLevel;
